import React from 'react';
import { Link } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-logo">
            {/* 1. CORRECCIÓN: Agregamos el '/' al inicio para que nunca se rompa la ruta */}
            <img src='/img/logo3.png' alt="VillaTracking Logo" />
            <p>Sistema de rastreo vehicular en tiempo real</p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://x.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-links-column">
              <h4>Empresa</h4>
              <ul>
                <li><RouterLink to="/about">Sobre Nosotros</RouterLink></li>
                <li><RouterLink to="/team">Nuestro Equipo</RouterLink></li>
                <li><RouterLink to="/careers">Carreras</RouterLink></li>
                <li><RouterLink to="/news">Noticias</RouterLink></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Soluciones</h4>
              <ul>
                <li><RouterLink to="/fleet-management">Gestión de Flota</RouterLink></li>
                <li><RouterLink to="/logistics">Logística</RouterLink></li>
                <li><RouterLink to="/delivery">Entregas</RouterLink></li>
                <li><RouterLink to="/security">Seguridad</RouterLink></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Soporte</h4>
              <ul>
                <li><RouterLink to="/help-center">Centro de Ayuda</RouterLink></li>
                
                {/* 2. NUEVO ENLACE AL MANUAL DE USUARIO */}
                <li>
                  <a href="/manual" target="_blank" rel="noopener noreferrer" className="external-footer-link">
                    Manual de Operador <span>↗</span>
                  </a>
                </li>

                <li><RouterLink to="/documentation">Documentación API</RouterLink></li>
                <li><RouterLink to="/tutorials">Tutoriales</RouterLink></li>
                <li><Link to="contact" spy={true} smooth={true} offset={-80} duration={500} style={{cursor: 'pointer'}}>Contacto</Link></li>
              </ul>
            </div>
            
            <div className="footer-links-column">
              <h4>Legal</h4>
              <ul>
                <li><RouterLink to="/terms">Términos de Servicio</RouterLink></li>
                <li><RouterLink to="/privacy">Política de Privacidad</RouterLink></li>
              </ul>
            </div>
          </div>
          
          <div className="footer-contact">
            <h4>Contáctanos</h4>
            <div className="footer-contact-info">
              <div className="footer-contact-item">
                <MapPin size={16} />
                <p>Los Laureles, Cabimas 4013, Estado Zulia, Venezuela</p>
              </div>
              <div className="footer-contact-item">
                <Phone size={16} />
                <p>+58 412 6594257</p>
              </div>
              <div className="footer-contact-item">
                <Mail size={16} />
                <p>soporte@villatracking.com</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} VillaTracking. Todos los derechos reservados.</p>
          <div className="footer-bottom-links">
            <RouterLink to="/terms">Términos</RouterLink>
            <RouterLink to="/privacy">Privacidad</RouterLink>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;